import { useNavigate } from "react-router-dom";
import { useMutation, MutationTuple } from "@apollo/client";
import { PERMISSION_UPDATE, PERMISSION_CREATE } from "graphql/mutation/permission-gql";
import PermissionConst from "../permission-const";
import {
    successNotification,
    errorNotification,
} from "components/request-result";

interface IPermissionCreateUpdateData {
    permissionUpdate?: {
        label: string;
        message: string;
    };
    permissionCreate?: {
        label: string;
        message: string;
    };
}

interface IPermissionCreateUpdateVariables {
    input: {
        id?: number;
        [key: string]: any;
    };
}

const useMutationPermissionCreateUpdate = (id: string | undefined, redirect: boolean = true) => {
    const navigate = useNavigate();

    const PERMISSION_CREATE_UPDATE = id ? PERMISSION_UPDATE : PERMISSION_CREATE;
    const permissionCreateUpdate = id ? "permissionUpdate" : "permissionCreate";

    const [_setPermissionCreateUpdate, { loading }]: MutationTuple<IPermissionCreateUpdateData, IPermissionCreateUpdateVariables> = useMutation(
        PERMISSION_CREATE_UPDATE,
        {
            update(cache, { data }) {
                if (data && data[permissionCreateUpdate]) {
                    const {
                        label,
                        message,
                    } = data[permissionCreateUpdate]!;

                    if (redirect) {
                        navigate(PermissionConst.basePath);
                    }

                    successNotification({
                        title: label,
                        description: message,
                    });
                }
            },
            onError(error) {
                errorNotification(error);
            },
        }
    );

    return {
        _setPermissionCreateUpdate,
        loadingMutationPermissionCreateUpdate: loading,
    };
};

export default useMutationPermissionCreateUpdate;